import { AutocompleteElement } from "@nosto/search-js/preact/autocomplete"
import { useNostoAppState } from "@nosto/search-js/preact/hooks"
import type { Product } from "@/types"
import DynamicCard from "@/elements/DynamicCard/DynamicCard"
import { isClearanceContext } from "@/mapping/clearanceContext"
import { getPreferredColor, getShopifyVariantId } from "@/utils/variantSelection"

type Props = {
  hit: Product
}

export default function DynamicCardProduct({ hit }: Props) {
  const searchQuery = useNostoAppState(state => state.query?.query)

  if (!hit.handle) {
    return null
  }

  const variantId = getShopifyVariantId(hit)
  const preferredColor = getPreferredColor(searchQuery)
  const isClearance = isClearanceContext(searchQuery)
  const showOnlyClearanceSwatches = isClearance || undefined
  const orderRegularSwatchesFirst = !isClearance || undefined

  return (
    <AutocompleteElement
      as={DynamicCard}
      hit={{
        productId: hit.productId!,
        url: hit.url
      }}
      componentProps={{
        handle: hit.handle,
        template: "card",
        variantId,
        preferredColor,
        showOnlyClearanceSwatches,
        orderRegularSwatchesFirst
      }}
    />
  )
}
